// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Hide not your face from me&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;in the day of my distress.<br> </p> </div></div>";
// Exports
module.exports = code;